<template>
  <b-row>
    <b-col cols="12">
      <regularization-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import RegularizationEditForm from './RegularizationEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    RegularizationEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
